var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tree-select',{class:[_vm.stateClass],attrs:{"placeholder":_vm.placeholder,"multiple":_vm.multiple,"flat":_vm.multiple,"options":_vm.options},on:{"select":_vm.selectNode,"deselect":_vm.deselectNode},model:{value:(_vm.local_value),callback:function ($$v) {_vm.local_value=$$v},expression:"local_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }